import { colors } from '@/common';
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import ClinicalTrials from '@/icons/ClinicalTrials.vue';
import AnalyticalTesting from '@/icons/AnalyticalTesting.vue';
import InDevelopment from '@/icons/InDevelopment.vue';
import Organizations from '@/icons/Organizations.vue';
import GeneTherapy from '@/icons/GeneTherapy.vue';
import CellTherapy from '@/icons/CellTherapy.vue';
import BioprocessingProduction from '@/icons/BioprocessingProduction.vue';
import LogisticsCompliance from '@/icons/LogisticsCompliance.vue';
import New from '@/icons/New.vue';
import PreclinicalStudies from '@/icons/PreclinicalStudies.vue';
import TissueEngineering from '@/icons/TissueEngineering.vue';
import Supportive from '@/icons/Supportive.vue';
import Standards from '@/icons/Standards.vue';
import ProductQuality from '@/icons/ProductQuality.vue';
import Published from '@/icons/Published.vue';
import PublishedReleased from '@/icons/PublishedReleased.vue';
import Recent from '@/icons/Recent.vue';
import Released from '@/icons/Released.vue';
import Revised from '@/icons/Revised.vue';
import AreaNeed from '@/icons/AreaNeed.vue';
import Scb from '@/icons/Scb.vue';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
        values: {
            AnalyticalTesting: { component: AnalyticalTesting },
            AreaNeed: { component: AreaNeed },
            Available: { component: PublishedReleased },
            BioprocessingProduction: { component: BioprocessingProduction },
            CellTherapy: { component: CellTherapy },
            ClinicalTrials: { component: ClinicalTrials },
            GeneTherapy: { component: GeneTherapy },
            InDevelopment: { component: InDevelopment },
            LogisticsCompliance: { component: LogisticsCompliance },
            New: { component: New },
            Organizations: { component: Organizations },
            PreclinicalStudies: { component: PreclinicalStudies },
            ProductQuality: { component: ProductQuality },
            Published: { component: Published },
            Recent: { component: Recent },
            Released: { component: Released },
            Revised: { component: Revised },
            Scb: { component: Scb },
            Standards: { component: Standards },
            Supportive: { component: Supportive },
            TissueEngineering: { component: TissueEngineering },
            Withdrawn: 'mdi-minus' // TODO: replace with real icon for Withdrawn
        }
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: colors
        }
    }
});
